import { WORD_APP_PATH, DOZEN_APP_PATH } from './config';

// Per-game chrome for AppShell: brand title, bottom tabs, footer rules link.
export const WORD_APP = {
  key: 'word',
  title: 'Слово Дня',
  homePath: `${WORD_APP_PATH}/game`,
  footerRules: [{ to: `${WORD_APP_PATH}/rules`, label: 'Правила' }],
  tabs: [
    { to: `${WORD_APP_PATH}/game`, label: 'Слово' },
    { to: `${WORD_APP_PATH}/leaderboard`, label: 'Лидеры' },
    { to: `${WORD_APP_PATH}/hall`, label: 'В паб!', title: 'Знаменитости Паба' }
  ]
};

export const DOZEN_APP = {
  key: 'dozen',
  title: 'Дюжина',
  homePath: `${DOZEN_APP_PATH}/game`,
  footerRules: [{ to: `${DOZEN_APP_PATH}/rules`, label: 'Правила' }],
  tabs: [
    { to: `${DOZEN_APP_PATH}/game`, label: 'Дюжина' },
    { to: `${DOZEN_APP_PATH}/leaderboard`, label: 'Лидеры' },
    { to: `${DOZEN_APP_PATH}/hall`, label: 'В тир!', title: 'Знаменитости Тира' }
  ]
};
